const getCategories = ({ routes, withSubNav }) =>
  routes.map(({ pageTitle: title, url: to, name, children }) => {
    const category = {
      title,
      to,
      name,
      dataTestId: name,
    }

    if (withSubNav && children) {
      category.subNav = getCategories({ routes: children, withSubNav })
    }

    return category
  })


export default getCategories
